@if (isOpen()) {
<app-modal
  [title]="'components.favoriteSearchesErrorModal.title' | transloco"
  [text]="'components.favoriteSearchesErrorModal.textDisclaimer' | transloco"
  [buttonText]="'components.favoriteSearchesErrorModal.ctaButtonText' | transloco"
  [type]="'primary'"
  (completeModal)="closeAndRedirect()"
  (closeModal)="close()"
></app-modal>
}
